import { onLCP, onINP, onCLS } from "web-vitals";

function sendToAnalytics(metric) {
  if (window.newrelic) {
    window.newrelic.addPageAction("web-vital", {
      metricName: metric.name,
      value: Math.round(metric.value),
      rating: metric.rating,
      path: window.location.pathname,
    });
  }
  if (window.dataLayer) {
    window.dataLayer.push({
      event: "web-vital",
      webVitalName: metric.name,
      webVitalValue: Math.round(metric.value),
      webVitalRating: metric.rating,
    });
  }
}

export function reportWebVitals() {
  onLCP(sendToAnalytics);
  onINP(sendToAnalytics);
  onCLS(sendToAnalytics);
}
